import React, { Component } from "react";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";

import EditableTable from "@components/Table/EditableTable";
import { api } from "@redux/api";
import { useAuth, AUTH_LEVEL } from "@/hooks/use-auth";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";

const LIST_PATH = "/admin/service-category";
const DETAIL_PATH = "/admin/service-category-detail";
const CREATE_PATH = "/admin/create-service-category";

const ServiceCategoryMobileHeader = ({ record, onOpen }) => (
  <span
    className="mcl-card-title mcl-card-title-link"
    title={record.name || ""}
    onClick={(event) => {
      event.stopPropagation();
      onOpen(record.id);
    }}
  >
    {record.name || "-"}
  </span>
);

const ServiceCategoryName = ({ id, name }) => {
  const { navigateAndCloseTabs } = useSmartNavigate();
  return (
    <a
      onClick={(event) => {
        event.stopPropagation();
        navigateAndCloseTabs(`${DETAIL_PATH}/${id}`, `${DETAIL_PATH}/`);
      }}
    >
      {name}
    </a>
  );
};

const columns = [
  {
    title: "key",
    dataIndex: "id",
    key: "id",
    editable: false,
    search: false,
    importIngore: true,
    hideInTable: true,
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    search: false,
    edit: true,
    sorter: true,
    formItemProps: {
      rules: [{ required: true, message: "required" }],
    },
    render: (text, record) => <ServiceCategoryName id={record.id} name={text} />,
    renderFormItem: () => <TextArea rows={1} />,
  },
  {
    title: "Comment",
    dataIndex: "comment",
    key: "comment",
    search: false,
    edit: true,
    ellipsis: true,
    renderFormItem: () => <TextArea rows={2} />,
  },
  {
    title: "Modified Date",
    dataIndex: "modified_date",
    key: "modified_date",
    search: false,
    edit: false,
    sorter: true,
    render: (value) => value ? moment(value).format("YYYY-MM-DD HH:mm") : "-",
  },
];

const columnProps = {
  title: "serviceCategory",
  name: "serviceCategory",
  description: "",
};

class ServiceCategory extends Component {
  state = {
    data: [],
  };

  handleFilter = (query) => api
    .filterServiceCategories(query || "")
    .then((response) => ({
      data: response.data.results || [],
      success: true,
      total: response.data.count || 0,
    }));

  getRecords = (data) => {
    this.setState({ data });
  };

  handleDelete = (id) => api.deleteServiceCategory(id);

  handleBulkDelete = (body) => {
    const payload = Array.isArray(body)
      ? { ids: body.map((row) => (row && typeof row === "object" ? row.id : row)).filter(Boolean) }
      : body;
    return api.bulkDeleteServiceCategories(payload);
  };

  handleOnlineSave = (id, row) => api.editServiceCategory(id, {
    name: row.name,
    comment: row.comment || "",
  });

  render() {
    return (
      <EditableTable
        columns={columns}
        data={this.state.data}
        columnProps={columnProps}
        getRecord={this.getRecords}
        deleteRecord={this.handleDelete}
        bulkDelete={this.handleBulkDelete}
        handOnlineSave={this.handleOnlineSave}
        handleFilter={this.handleFilter}
        hide_imports
        isRowClickable={false}
        isRelated={false}
        isAttachments={false}
        hid_new={!this.props.canWrite}
        canDelete={this.props.canFullAccess}
        new_text="Create Service Category"
        onNew={() => this.props.navigate(CREATE_PATH)}
        onDoubleClick={(record) =>
          this.props.navigateAndCloseTabs(`${DETAIL_PATH}/${record.id}`, `${DETAIL_PATH}/`)
        }
        mobileCardHeaderRender={(record) => (
          <ServiceCategoryMobileHeader
            record={record}
            onOpen={(id) => this.props.navigateAndCloseTabs(
              `${DETAIL_PATH}/${id}`,
              `${DETAIL_PATH}/`
            )}
          />
        )}
        mobileExpandedExcludeKeys={["id"]}
      />
    );
  }
}

const ServiceCategoryWithHooks = (props) => {
  const canWrite = useAuth("serviceCategory", AUTH_LEVEL.WRITE);
  const canFullAccess = useAuth("serviceCategory", AUTH_LEVEL.FULL_ACCESS);
  const { navigate, navigateAndCloseTabs } = useSmartNavigate();
  return (
    <ServiceCategory
      {...props}
      canWrite={canWrite}
      canFullAccess={canFullAccess}
      navigate={navigate}
      navigateAndCloseTabs={navigateAndCloseTabs}
    />
  );
};

export { LIST_PATH };
export default ServiceCategoryWithHooks;
